import React, { useEffect, useState } from 'react';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/20/solid';

interface CandidateRightSidebarProps {
    title?: string;
    children?: React.ReactNode;
    handleAdminOptionClick: Function
    adminOptionFlag: number
}

const CandidateRightSidebar: React.FC<CandidateRightSidebarProps> = ({ 
    title = 'Test Actions', 
    children,
    handleAdminOptionClick,
    adminOptionFlag
}) => {
    const [adminbuttonState , setadminbuttonState] = useState(0)
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleSidebar = () => {
        setIsOpen((prev) => !prev);
    };
    

    return (
        <aside
            className={`select-none fixed z-10 top-[4.1rem] h-[calc(99vh-4rem)] right-0 shadow-md border dark:border-gray-500 transition-transform transform duration-200 w-[19rem] bg-white dark:bg-darkbg ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
        >
            <div className="mx-auto bg-gray-100 dark:bg-darkbglight">
                <div className="min-w-0 px-4 pt-2 pb-1">
                    <div className="text-gray-900 dark:text-gray-300 flex items-center space-x-2 justify-center">
                        <h3 className="text-center text-lg font-semibold leading-7 sm:text-base sm:tracking-tight">
                            {title}
                        </h3>
                    </div>
                </div>
            </div>

            <div
                className={`absolute top-10 ${isOpen ? '-left-2 shadow-md' : '-left-4 shadow-xl'} h-16 border border-gray-300 rounded-md flex items-center justify-center cursor-pointer bg-white dark:bg-darkbglight dark:border-gray-500 dark:text-gray-300`}
                onClick={toggleSidebar}
            >
                {isOpen ? <ChevronDoubleRightIcon width={16} /> : <ChevronDoubleLeftIcon width={16} />}
            </div>
{adminOptionFlag === 0 && (
    <p className="text-sm text-yellow-700 dark:text-yellow-300 px-4 pt-2">
        Test is paused. Click on "Start Test" to allow candidates to start test.
    </p>
)}
{adminOptionFlag === 1 && (
    <p className="text-sm text-green-700 dark:text-green-300 px-4 pt-2">
        The test has been started. Candidates can now start the test.
    </p>
)}
{adminOptionFlag === -1 && (
    <p className="text-sm text-red-700 dark:text-red-300 px-4 pt-2">
        The test has been cancelled.
    </p>
)}
            <div className="pb-12 h-full thin-scroll overflow-y-auto w-full flex flex-col mt-2 px-4 text-gray-700 dark:text-gray-200">
                <div className="flex flex-col gap-3 w-full">
                    <button
                        type="button"
                        onClick={()=>{handleAdminOptionClick(1)}}
                        className="inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-600 dark:hover:bg-indigo-500"
                   >
                        {adminOptionFlag==1?"Started":"Start Test"}
                    </button>
                    <button
                        type="button"
                        onClick={()=>{handleAdminOptionClick(0)}}
                        className="inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 dark:bg-darkbglight dark:text-gray-200 dark:ring-gray-500 dark:hover:bg-darkbg"
                    >
                        Pause Test
                    </button>
                    <button
                        type="button"
                        onClick={()=>{handleAdminOptionClick(-1)}}
                        className="inline-flex justify-center rounded-md bg-red-500 px-4 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-red-500 hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 dark:bg-red-600 dark:hover:bg-red-700"
                    >
                        Cancel Test
                    </button>
                </div>
                {children && (
                    <div className="mt-4 w-full">
                        {children}
                    </div>
                )}
            </div>
        </aside>
    );
};

export default CandidateRightSidebar;
